import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_HOST } from "../../constants/constants";
import { prepareHeaders } from "./bearer";

const personalInfoApi = createApi({
  reducerPath: "personalInfo",
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_HOST,
    prepareHeaders,
  }),
  endpoints(builder) {
    return {
      // Accounts Pages
      fetchMe: builder.query({
        query: () => {
          return {
            method: "GET",
            url: "users/me",
          };
        },
      }),
      updatePersonalInfo: builder.mutation({
        query: (body) => {
					
          return {
            method: "PUT",
            url: "/users/personal-info",
            body,
          };
        },
      }),
      updateIncomesInfo: builder.mutation({
        query: ({ year, ...body }) => {
          return {
            method: "PUT",
            url: `/users/other-income/${year}`,
            body,
          };
        },
        invalidatesTags: ['other-income']
      }),
      getPersonalInfo: builder.query({
        query: () => {

          return {
            method: "GET",
            url: "/users/personal-info",
          };
        },
      }),
      getIncomesInfo: builder.query({
        query: ({ year }) => {
          return {
            method: "GET",
            url: `/users/other-income/${year}`,
          };
        },
        provides: ['other-income'],
      }),
		}
  },
});

export const {
	useFetchMeQuery,
	useUpdatePersonalInfoMutation,
  useGetPersonalInfoQuery,
  useUpdateIncomesInfoMutation,
  useGetIncomesInfoQuery,
} = personalInfoApi;
export { personalInfoApi };

